export const IMPLANT_CREATE_TREATMENT_PLAN = 'implant_create_treatment_plan'

export const IMPLANT_REVIEW_TREATMENT_PLAN = 'implant_review_treatment_plan'

export const IMPLANT_CREATE_TREATMENT_QUOTATION = 'implant_create_treatment_quotation'

export const QM_REVIEW_TREATMENT_PLAN_INTERNAL = 'qm_review_treatment_plan_internal'




// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/implant-plan/task-name.js